import { gql } from '@grandvisionhq/graphql';
import '../fragments/checkout-mutation-result.js';
import '../fragments/cart-mutation-failures.js';
import '../fragments/recreate-ordered-checkout-failure.js';
import '../fragments/recreate-ordered-checkout-result.js';
import '../fragments/paypal-payment.js';
import { savedUserDetails } from '../fragments/saved-user-details.js';

const GET_SAVED_USER_DETAILS = gql`
  query GetSavedUserDetails {
    me {
      id
      ...SavedUserDetailsFragment
      preferredStore {
        code
      }
    }
  }
  ${savedUserDetails}
`;

export { GET_SAVED_USER_DETAILS };
//# sourceMappingURL=get-user-details.js.map
